<template>
    <tr>
        <td>
            {{ format(name) }}
        </td>
        <td v-for="rate in chosenRates">
            {{ row[rate] ? currencyFormat(row[rate]) : currencyFormat(0) }}
        </td>
        <td v-if="chosenRates.length === 2">
            {{ currency(row[chosenRates[0]], row[chosenRates[1]]) }}
        </td>
        <td v-if="chosenRates.length === 2">
            {{ roundAndPercent(row[chosenRates[0]], row[chosenRates[1]]) }}%
        </td>
    </tr>
</template>

<script>
    import _ from 'lodash';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import currencyFormat from 'mixins/currencyFormat';
    import percentageDifference from 'mixins/percentageDifference';
    import roundValue from 'mixins/roundValue';

    export default {
        name: 'head-of-loss-row',
        mixins: [
            currencyFormat,
            percentageDifference,
            roundValue,
        ],
        props: {
            name: {
                type: String,
                default: null,
            },
            row: {
                type: Object,
                default: null,
            }
        },
        computed: {
            ...mapState('discountRateComparison', [
                'chosenRates',
            ]),
        },
        methods: {
            format(name) {
                // Hacky but we will tidy up later.
                return _.startCase(name).replace('Diy', 'DIY');
            },
            currency(val1, val2) {
                return this.currencyFormat((val1) - (val2));
            },
            roundAndPercent(val1, val2) {
                return this.roundValue(this.percentageDifference(this.roundValue(val1, 2), this.roundValue(val2, 2)), 2);
            },
        },
    }
</script>



// WEBPACK FOOTER //
// HeadOfLossRow.vue?00479e54